// A dolphin, modelled facing +X: a sleek grey body, a curved dorsal fin, a long
// beak and a fluked tail. Ported 1:1 from age-of-mcp's classic dolphin.ts.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  return [
    { geometry: new THREE.IcosahedronGeometry(0.05, 0), color: "#7f93a2",
      position: [0, 0.04, 0], scale: [2.2, 0.95, 0.85] },           // body
    { geometry: new THREE.IcosahedronGeometry(0.03, 0), color: "#aebcc6",
      position: [0.02, 0.024, 0], scale: [2, 0.7, 0.8] },           // pale belly
    { geometry: new THREE.ConeGeometry(0.018, 0.05, 5), color: "#8fa1ae",
      position: [0.095, 0.045, 0], rotation: [0, 0, -Math.PI / 2] },  // beak
    { geometry: new THREE.ConeGeometry(0.018, 0.05, 3), color: "#6e8492",
      position: [-0.005, 0.085, 0], rotation: [0, 0, -0.5], scale: [1, 1, 0.3] }, // dorsal
    { geometry: new THREE.ConeGeometry(0.026, 0.05, 3), color: "#6e8492",
      position: [-0.085, 0.04, 0], rotation: [0, 0, Math.PI / 2], scale: [1, 1, 0.25] }, // fluke
    { geometry: new THREE.IcosahedronGeometry(0.004, 0), color: "#101418",
      position: [0.07, 0.05, 0.018] },                              // eye
    { geometry: new THREE.IcosahedronGeometry(0.004, 0), color: "#101418",
      position: [0.07, 0.05, -0.018] },
  ];
}

export const dolphin = defineModel({
  id: "dolphin",
  scale: 2.2, // real-world size correction (see Model.scale)
  batchId: "standard",
  name: "Dolphin",
  tags: ["creature","dolphin","low-poly","age-of-mcp","classic","water"],
  summary: "Low-poly dolphin.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.12,
  parts: () => partsFor(),
  animations: [],
});
